import { render } from "./HomeView.vue?vue&type=template&id=bfa81ef2"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Unimagem\\api_adm_unimagem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__